import { render, staticRenderFns } from "./flownode_config_detail.vue?vue&type=template&id=6002620e&scoped=true"
import script from "./flownode_config_detail.vue?vue&type=script&lang=js"
export * from "./flownode_config_detail.vue?vue&type=script&lang=js"
import style0 from "./flownode_config_detail.vue?vue&type=style&index=0&id=6002620e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6002620e",
  null
  
)

export default component.exports